<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-form
        :model="where"
        label-width="77px"
        class="ele-form-search"
        @keyup.enter.native="reload"
        @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="6" :md="12">
            <el-form-item label="系统订单">
              <el-input clearable v-model.trim="where.orderNo" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="主体类型">
              <el-select clearable class="ele-block" v-model="where.party_type" placeholder="请选择">
                <el-option
                  v-for="item in partyTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="交易状态">
              <el-select clearable class="ele-block" v-model="where.order_status" placeholder="请选择">
                <el-option
                  v-for="item in orderStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="账变状态">
              <el-select clearable class="ele-block" v-model="where.is_balance" placeholder="请选择">
                <el-option
                  v-for="item in isBalanceOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="派单状态">
              <el-select clearable class="ele-block" v-model="where.handle_status" placeholder="请选择">
                <el-option
                  v-for="item in handleStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="16" :md="24">
            <el-form-item label="选择时间">
              <div class="verifyorder-time-wrap">
                <el-radio-group v-model="timeQuick" size="small" @change="onTimeQuickChange">
                  <el-radio-button label="today">今日</el-radio-button>
                  <el-radio-button label="yesterday">昨日</el-radio-button>
                  <el-radio-button label="week">本周</el-radio-button>
                  <el-radio-button label="month">本月</el-radio-button>
                  <el-radio-button label="lastMonth">上月</el-radio-button>
                  <el-radio-button label="days30">30日</el-radio-button>
                </el-radio-group>
                <el-date-picker
                  v-model="where.time"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  @change="onTimePickerChange" />
              </div>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="reload">查询</el-button>
              <el-button @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <div class="verifyorder-stat-bar">
        <span>订单总量: {{ dataList.total_count }}</span>
        <span>成功数量: {{ dataList.success_count }}</span>
        <span>失败数量: {{ dataList.fail_count }}</span>
        <span>订单总金额: {{ dataList.total_amount }}</span>
        <span>成功金额: {{ dataList.success_amount }}</span>
        <span>失败金额: {{ dataList.fail_amount }}</span>
        <span>成功率: {{ dataList.success_rate }}</span>
        <span>USDT总量: {{ dataList.total_usdt }}</span>
        <span>成功USDT: {{ dataList.success_usdt }}</span>
        <span>已派单: {{ dataList.handle_count }}</span>
      </div>

      <ele-pro-table
        ref="table"
        :where="where"
        :datasource="url"
        :columns="columns"
        :page-size="20"
        :page-sizes="[20, 50, 100]"
        height="calc(100vh - 360px)">
        <template slot="toolbar">
          <el-button
            size="small"
            type="primary"
            icon="el-icon-s-finance"
            class="ele-btn-icon"
            @click="showRate = true"
            v-if="permission.includes('sys:verifyorder:edit')">
            承兑汇率
          </el-button>
          <el-button size="small" type="warning" icon="el-icon-refresh" class="ele-btn-icon" @click="initData"
            v-if="permission.includes('sys:verifyorder:edit')">
            初始化
          </el-button>
        </template>
        <template slot="partyType" slot-scope="{ row }">
          <dict-tag dict-code="party_type" :value="row.party_type" :show-value="false" />
        </template>
        <template slot="payInfo" slot-scope="{ row }">
          <div>
            <div>方式: <dict-tag dict-code="pay_account_type" :value="row.pay_type" :show-value="false" text-only /></div>
            <div>姓名: {{ row.inPayerName }}</div>
            <div v-if="isCollectQr(row.inPayerAccount)">
              账号: 收款码
              <el-button type="text" size="mini" @click="openCollectQr(row)">查看</el-button>
            </div>
            <div v-else>账号: {{ row.inPayerAccount }}</div>
            <div v-if="row.pay_type === 'bank' && !isCollectQr(row.inPayerAccount)">银行: {{ row.inPayerBankName }}</div>
          </div>
        </template>
        <template slot="orderStatus" slot-scope="{ row }">
          <dict-tag dict-code="verify_order_status" :value="row.order_status" :show-value="false" />
        </template>
        <template slot="isBalance" slot-scope="{ row }">
          <dict-tag dict-code="order_related_status" field="is_balance" :value="row.is_balance" :show-value="false" text-only />
        </template>
        <template slot="handleStatus" slot-scope="{ row }">
          <dict-tag dict-code="verify_handle_status" :value="row.handle_status" :show-value="false" />
        </template>
        <template slot="proof" slot-scope="{ row }">
          <el-button
            v-if="row.proof_image_url || row.proof_image"
            size="mini"
            type="text"
            @click="openProof(row)">
            查看
          </el-button>
        </template>
        <template slot="action" slot-scope="{ row }">
          <el-button
            v-if="Number(row.handle_status) !== 1 && permission.includes('sys:verifyorder:edit')"
            size="mini"
            type="primary"
            class="ele-btn-icon"
            @click="openHandle(row)">
            派单
          </el-button>
          <el-button
            v-if="Number(row.order_status) === 6 && permission.includes('sys:verifyorder:edit')"
            size="mini"
            type="warning"
            class="ele-btn-icon"
            @click="openUpdateStatus(row)">
            更新
          </el-button>
          <span
            v-if="Number(row.handle_status) === 1 && Number(row.order_status) !== 6"
            class="ele-text-secondary">
            已派单
          </span>
        </template>
      </ele-pro-table>
    </el-card>

    <acceptor-rate-dialog :visible.sync="showRate" />
    <handle-dialog :visible.sync="showHandle" :order="handleOrder" @done="reload" />
    <update-status-dialog :visible.sync="showUpdateStatus" :order="updateOrder" @done="onPayStatusUpdated" />

    <el-dialog
      title="付款凭证"
      :visible.sync="showProof"
      width="480px"
      top="4vh"
      append-to-body
      :lock-scroll="false"
      custom-class="verify-proof-dialog">
      <div v-if="proofReason" class="proof-reason">原因：{{ proofReason }}</div>
      <div class="proof-wrap">
        <img v-if="proofUrl" :src="proofUrl" class="proof-image" alt="付款凭证">
        <div v-else class="ele-text-secondary">暂无凭证</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getDictData, loadDictOptions } from '@/utils/dict';
import AcceptorRateDialog from './acceptor-rate-dialog';
import HandleDialog from './handle-dialog';
import UpdateStatusDialog from './update-status-dialog';

const EMPTY_STATS = {
  total_count: 0,
  success_count: 0,
  fail_count: 0,
  total_amount: '0',
  success_amount: '0',
  fail_amount: '0',
  success_rate: '0%',
  total_usdt: '0',
  success_usdt: '0',
  handle_count: 0
};

export default {
  name: 'TransactionVerifyOrder',
  components: { AcceptorRateDialog, HandleDialog, UpdateStatusDialog },
  computed: {
    ...mapGetters(['permission'])
  },
  data() {
    return {
      url: '/VerifyOrder/index',
      columns: [
        { prop: 'id', label: '序号', width: 70, align: 'center', showOverflowTooltip: true, fixed: 'left' },
        { prop: 'username', label: '用户名称', minWidth: 120, align: 'center', showOverflowTooltip: true, fixed: 'left' },
        { prop: 'party_type', label: '主体类型', minWidth: 100, align: 'center', slot: 'partyType' },
        { prop: 'orderNo', label: '系统订单', minWidth: 180, align: 'center', showOverflowTooltip: true },
        { prop: 'amount', label: '金额', minWidth: 110, align: 'center', showOverflowTooltip: true },
        { prop: 'usdt', label: 'USDT', minWidth: 120, align: 'center', showOverflowTooltip: true },
        { prop: 'rate', label: '汇率', minWidth: 100, align: 'center', showOverflowTooltip: true },
        { prop: 'acceptor_name', label: '承兑', minWidth: 140, align: 'center', showOverflowTooltip: true },
        { columnKey: 'payInfo', label: '收款信息', prop: 'payInfo', minWidth: 220, align: 'left', slot: 'payInfo' },
        { prop: 'order_status', label: '交易状态', minWidth: 100, align: 'center', slot: 'orderStatus' },
        { columnKey: 'proof', label: '付款凭证', width: 100, align: 'center', slot: 'proof' },
        { prop: 'is_balance', label: '账变状态', minWidth: 100, align: 'center', slot: 'isBalance' },
        { prop: 'handle_status', label: '派单状态', minWidth: 100, align: 'center', slot: 'handleStatus' },
        { prop: 'finance_name', label: '派发财务', minWidth: 120, align: 'center', showOverflowTooltip: true },
        {
          prop: 'create_time',
          label: '创建时间',
          minWidth: 170,
          align: 'center',
          showOverflowTooltip: true,
          formatter: (row, column, cellValue) => this.$util.toDateString(cellValue)
        },
        {
          prop: 'update_time',
          label: '更新时间',
          minWidth: 170,
          align: 'center',
          showOverflowTooltip: true,
          formatter: (row, column, cellValue) => this.$util.toDateString(cellValue)
        },
        { columnKey: 'action', label: '操作', width: 140, align: 'center', resizable: false, slot: 'action', fixed: 'right' }
      ],
      where: { time: null },
      timeQuick: 'today',
      showRate: false,
      showHandle: false,
      handleOrder: null,
      showUpdateStatus: false,
      updateOrder: null,
      showProof: false,
      proofUrl: '',
      proofReason: '',
      dataList: { ...EMPTY_STATS },
      orderStatusOptions: [],
      isBalanceOptions: [],
      partyTypeOptions: [],
      handleStatusOptions: []
    };
  },
  created() {
    this.applyTimeQuick('today', false);
  },
  mounted() {
    getDictData('order_related_status');
    getDictData('pay_account_type');
    getDictData('verify_order_status');
    Promise.all([
      loadDictOptions('party_type', { numberValue: true }),
      loadDictOptions('verify_order_status', { numberValue: true }),
      loadDictOptions('yes_no'),
      loadDictOptions('verify_handle_status', { numberValue: true })
    ]).then(([partyType, orderStatus, isBalance, handleStatus]) => {
      this.partyTypeOptions = partyType;
      this.orderStatusOptions = orderStatus;
      this.isBalanceOptions = isBalance;
      this.handleStatusOptions = handleStatus;
    }).catch((e) => {
      this.$message.error(e.message);
    });
    this.getVerifyOrderCount();
  },
  methods: {
    pad2(n) {
      return n < 10 ? `0${n}` : `${n}`;
    },
    formatDateTime(date) {
      const d = date instanceof Date ? date : new Date(date);
      return `${d.getFullYear()}-${this.pad2(d.getMonth() + 1)}-${this.pad2(d.getDate())} ${this.pad2(d.getHours())}:${this.pad2(d.getMinutes())}:${this.pad2(d.getSeconds())}`;
    },
    getTimeRange(key) {
      const now = new Date();
      const start = new Date(now);
      const end = new Date(now);
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 0);

      if (key === 'today') {
        return [this.formatDateTime(start), this.formatDateTime(end)];
      }
      if (key === 'yesterday') {
        start.setDate(start.getDate() - 1);
        end.setDate(end.getDate() - 1);
        return [this.formatDateTime(start), this.formatDateTime(end)];
      }
      if (key === 'week') {
        const day = start.getDay() || 7;
        start.setDate(start.getDate() - day + 1);
        return [this.formatDateTime(start), this.formatDateTime(end)];
      }
      if (key === 'month') {
        start.setDate(1);
        return [this.formatDateTime(start), this.formatDateTime(end)];
      }
      if (key === 'lastMonth') {
        start.setMonth(start.getMonth() - 1, 1);
        end.setDate(0);
        end.setHours(23, 59, 59, 0);
        return [this.formatDateTime(start), this.formatDateTime(end)];
      }
      if (key === 'days30') {
        start.setDate(start.getDate() - 29);
        return [this.formatDateTime(start), this.formatDateTime(end)];
      }
      return null;
    },
    applyTimeQuick(key, doReload = true) {
      this.timeQuick = key;
      this.where.time = this.getTimeRange(key);
      if (doReload) this.reload();
    },
    onTimeQuickChange(key) {
      this.applyTimeQuick(key, true);
    },
    onTimePickerChange() {
      this.timeQuick = '';
    },
    reload() {
      this.$refs.table.reload({ where: this.where });
      this.getVerifyOrderCount();
    },
    reset() {
      this.where = { time: null };
      this.applyTimeQuick('today', true);
    },
    getVerifyOrderCount() {
      this.$http.post('/VerifyOrder/getVerifyOrderCount', this.where).then((res) => {
        if (res.data.code === 0) {
          this.dataList = res.data.data || { ...EMPTY_STATS };
          return;
        }
        this.$message.error(res.data.msg);
      }).catch((e) => {
        this.$message.error(e.message);
      });
    },
    openHandle(row) {
      this.handleOrder = row
        ? { id: row.id, orderNo: row.orderNo, amount: row.amount, usdt: row.usdt }
        : null;
      this.showHandle = true;
    },
    openUpdateStatus(row) {
      this.updateOrder = row ? { id: row.id, orderNo: row.orderNo } : null;
      this.showUpdateStatus = true;
    },
    onPayStatusUpdated() {
      if (this.where && Object.prototype.hasOwnProperty.call(this.where, 'order_status')) {
        this.$delete(this.where, 'order_status');
      }
      this.reload();
    },
    isCollectQr(account) {
      return !!(account && String(account).indexOf('/uploads/collect_qr/') === 0);
    },
    openCollectQr(row) {
      this.proofUrl = this.resolveProofUrl(row && row.inPayerAccount);
      this.proofReason = '';
      this.showProof = true;
    },
    openProof(row) {
      const relative = row && row.proof_image;
      const absolute = row && row.proof_image_url;
      let url = '';
      if (relative && relative.indexOf('/uploads/') === 0) {
        url = relative;
      } else if (absolute) {
        url = absolute;
      } else {
        url = relative;
      }
      this.proofUrl = this.resolveProofUrl(url);
      this.proofReason = (row && row.proof_reason) ? String(row.proof_reason) : '';
      this.showProof = true;
    },
    resolveProofUrl(url) {
      if (!url) return '';
      const base = (process.env.VUE_APP_API_BASE_URL || '').replace(/\/$/, '');
      if (url.indexOf('/uploads/') >= 0) {
        const path = url.substring(url.indexOf('/uploads/'));
        return `${base}${path}`;
      }
      if (/^https?:\/\//i.test(url)) return url;
      return url.startsWith('/') ? `${base}${url}` : url;
    },
    initData() {
      this.$confirm('初始化将清空全部核销订单且不可恢复，确定继续？', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({ lock: true });
        this.$http.post('/VerifyOrder/initData').then((res) => {
          loading.close();
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.reload();
            return;
          }
          this.$message.error(res.data.msg);
        }).catch((e) => {
          loading.close();
          this.$message.error(e.message);
        });
      }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.verifyorder-stat-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 28px;
  margin-bottom: 12px;
  padding: 10px 16px;
  background: #f5f7fa;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
}

.verifyorder-time-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.proof-reason {
  margin-bottom: 10px;
  padding: 8px 10px;
  background: #fdf6ec;
  border: 1px solid #faecd8;
  border-radius: 4px;
  color: #e6a23c;
  font-size: 13px;
  line-height: 1.5;
  word-break: break-all;
}

.proof-wrap {
  max-height: calc(92vh - 150px);
  overflow: auto;
  text-align: center;
  background: #f5f7fa;
  padding: 8px;
}

.proof-image {
  display: block;
  width: 100%;
  height: auto;
  margin: 0 auto;
}
</style>

<style>
.verify-proof-dialog .el-dialog__body {
  padding: 12px 16px 16px;
  overflow: hidden;
}
</style>
